




















































import Vue from 'vue';
import api from '@/common/api';
import LoadingModal from '@/common/components/LoadingModal.vue';
import { ReceiptSetting, initReceiptSetting, ReceiptSettingCategory } from './support.types';
import ReceiptSettingLogoPicker from './ReceiptSettingLogoPicker.vue';

export default Vue.extend({
  data() {
    return {
      newReceiptSetting: initReceiptSetting() as ReceiptSetting,
      valid: true,
      isSubmitting: false as boolean,
      showModal: false as boolean,
      ReceiptSettingCategory,
      receiptCategories: Object.values(ReceiptSettingCategory) as string[],
      logo: '' as string,
    };
  },
  methods: {
    updateLogo(logo: string) {
      this.logo = logo;
    },
    submitActions(isSubmitting: boolean) {
      this.isSubmitting = isSubmitting;
    },
    save() {
      if (!this.isValid()) {
        return;
      }

      this.submitActions(true);

      const val = this.isLogo() ? this.logo : this.newReceiptSetting.value;

      api
        .post('/receipt-settings', {
          name: this.newReceiptSetting.name,
          value: val,
          enabled: this.newReceiptSetting.enabled,
          category: this.newReceiptSetting.category,
        })
        .then(() => {
          this.logo = '';
          this.newReceiptSetting = initReceiptSetting();
          this.$emit('created');
          (this.$refs.form as any).resetValidation();
          this.close();
        })
        .catch(({ response }: { response: any }) => {
          this.logo = '';
          this.$toasted.error(`There was a problem creating new receipt setting. (${response.status})`);
          this.close();
        });
    },
    show() {
      this.showModal = true;
    },
    close() {
      this.submitActions(false);
      this.newReceiptSetting = initReceiptSetting();
      this.showModal = false;
    },
    isValid(): boolean {
      return (this.$refs.form as any).validate();
    },
    isLogo(): boolean {
      return this.newReceiptSetting.category === ReceiptSettingCategory.LOGO;
    },
  },
  components: {
    LoadingModal,
    ReceiptSettingLogoPicker,
  },
});
